import { accordionStyles, accordionTemplate } from "@fluentui/web-components";
import { DesignSystem } from "../design-system.js";
import { Accordion } from "./accordion.js";
/**
 * The Fabric Accordion component.
 *
 * @public
 * @remarks
 * HTML Element: <fabric-accordion>
 */
export const definition = Accordion.compose({
    name: `${DesignSystem.prefix}-accordion`,
    template: accordionTemplate,
    styles: accordionStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=accordion.definition.js.map